/* eslint-disable react-hooks/exhaustive-deps */
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import {
  Avatar,
  Box,
  IconButton,
  Menu,
  MenuItem,
  Paper,
  Typography,
} from "@mui/material";
import useChangeLanguage from "common/hooks/useChangeLanguage";
import _ from "lodash";
import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useLogin } from "../../auth/hooks/useLogin";
import useGetImage from "../../common/hooks/useGetImage";
import { getUserSession } from "../../helper/user";
import { setOpenMenu } from "../../redux/themeReducer";
import ChangeRole from "./ChangeRole";
import LanguageButton, { LIST_LANGUAGUE } from "./LanguageButton";
import { useFetch } from "common/hooks/useFetch";
import { CommonAPI } from "../../api/Channel/Common";
import {
  KEY_ROLE_BIZZ_UAA,
  ROLE,
  TYPE_CONFIG,
} from "modules/Channel/configs/constant";
import { queryKeys } from "helper/react-query";
import { useMutation } from "react-query";
import { LOCAL_STORAGE, getDataSession } from "helper/session";

export const HeaderMenu = () => {
  const dispatch = useDispatch();
  // @ts-ignore
  const { open } = useSelector((state) => state.theme);
  const { changeLanguage } = useChangeLanguage();
  const { logoutAccount } = useLogin();
  const [anchorEl, setAnchorEl] = useState(null);
  const openMenu = Boolean(anchorEl);
  const userInfo = getUserSession();
  const { t } = useTranslation("common");
  const { handleGetUrlImage, urlImage } = useGetImage();
  const currentUserRole = getDataSession(LOCAL_STORAGE, KEY_ROLE_BIZZ_UAA);

  const { data: dataUserLanguage, isLoading: isLoadingGetUserLanguage } =
    useFetch(
      CommonAPI.getUserLanguage,
      TYPE_CONFIG.OTP_CHANNEL,
      queryKeys.USER_LANGUAGE,
      {
        enabled: currentUserRole?.code !== ROLE.ADMIN,
      }
    );
  // @ts-ignore
  const { currentBizzApp } =
    useSelector((state) => _.get(state, "bizzApps")) || {};

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const linkImage = useMemo(() => userInfo?.imageUrl, [userInfo]);

  useEffect(() => {
    if (linkImage) {
      handleGetUrlImage(linkImage);
    }
  }, [linkImage]);

  const { mutateAsync: changeUserLanguage } = useMutation({
    mutationFn: CommonAPI.changeUserLanguage,
  });

  useEffect(() => {
    if (dataUserLanguage) {
      const currentLangue = LIST_LANGUAGUE.find(
        (v) => v.codeHeader === dataUserLanguage.language
      );

      changeLanguage(currentLangue.code.toLowerCase());
    } else {
      changeLanguage("eng");
    }
  }, [dataUserLanguage]);

  return (
    <Paper
      className="flex flex-row h-31 w-full bg-white items-center justify-between sticky top-0 rounded-none"
      style={{ zIndex: 1000 }}
      elevation={2}
    >
      <Box>
        {!open && (
          <IconButton onClick={() => dispatch(setOpenMenu(true))}>
            <MenuOpenIcon fontSize="small" />
          </IconButton>
        )}
      </Box>
      {/* 
      {currentBizzApp && currentBizzApp.alias === "channel" ? (
        <ChangeRole />
      ) : null} */}

      <Box className="flex justify-end items-center mr-10">
        {!isLoadingGetUserLanguage && (
          <LanguageButton changeUserLanguage={changeUserLanguage} />
        )}
        {/* <LanguageButton /> */}
        <div className="ml-10">
          <Typography>
            {userInfo.firstName}
            &nbsp;
            {userInfo.lastName}
          </Typography>
        </div>
        <IconButton onClick={handleClick}>
          <Avatar src={urlImage} />
        </IconButton>
      </Box>
      <Menu anchorEl={anchorEl} open={openMenu} onClose={handleClose}>
        {/* <MenuItem onClick={() => navigate("/user")}>
          {t("account_info")}
        </MenuItem> */}

        {currentBizzApp && currentBizzApp.alias === "channel" ? (
          <MenuItem className="p-0">
            <ChangeRole />
          </MenuItem>
        ) : null}
        <MenuItem onClick={logoutAccount}>{t("logout")}</MenuItem>
      </Menu>
    </Paper>
  );
};
